// extracted by mini-css-extract-plugin
module.exports = {"spacer":"spacer_spacer__Q1a01","spacer_size":"spacer_spacer_size__2ZPx3"};